// Copyright (c) 2017 Deere & Company

import LaborAdditivePipsMain from './labor-additive-pips-main';
import actionCreators from '../../action-creators';
import {connect} from 'react-redux';

const getStateToBindToContainerProps = state => ({
    busyCounter: state.pips.laborAdditive.busyCounter,
    exportToExcel: state.exportToExcel,
    facets: state.pips.laborAdditive.facets,
    hasSearchResults: state.pips.laborAdditive.hasSearchResults,
    isMoreSummaryVisible: state.pips.laborAdditive.isMoreSummaryVisible,
    isVisible: state.pips.laborAdditive.isVisible,
    laborAdditiveSummaries: state.pips.laborAdditive.laborAdditiveSummaries,
    laborAdditiveSummary: state.pips.laborAdditive.laborAdditiveSummary,
    openPipProductsCount: state.pips.openPips.pipProducts.length,
    pipProductsCount: state.pips.laborAdditive.pipProducts.length,
    pipProductsFiltered: state.pips.laborAdditive.pipProductsFiltered,
    searchFilters: state.pips.laborAdditive.searchFilters,
    searchResultsCount: state.pips.pipSearch.searchResults.length,
    user: state.user.details
});

const mapBoundActionCreatorsToActionsProp = (stateProps, dispatchProps, parentProps) => {

    const {routeParams} = parentProps;

    return {
        ...stateProps,
        actions: {
            ...dispatchProps
        },
        routeParams
    };

};

export default connect(getStateToBindToContainerProps, actionCreators, mapBoundActionCreatorsToActionsProp)(LaborAdditivePipsMain);



// WEBPACK FOOTER //
// ./src/pip/labor-additive/components/labor-additive-pips-main/index.js